<template>
    <div class="pt-prj@until-medium py-0 align-content-center flex-child-auto">
        <slot name="top"/>

        <slot/>

    </div>
</template>

<script>
import OptionAuflage from 'components/OptionAuflage.vue'
import optionWidth from "mixins/optionWidth.js";

export const AUFLAGE_ZAHL = "auflagezahl";

export default {
  name: "OptionGroupMain.vue",
  props: ['group'],
  inject: ['globalConfig', 'optionsService'],
  components: {OptionAuflage},
  mixins: [optionWidth],
  data() {
          return {}
        },

        computed: {

        },
        methods: {
        }

    }
</script>
